import { z } from "zod";

export const projectDetailsSchema = z.string().trim()
  .min(1, "Please tell us about your project.")
  .max(500, "Project details must be 500 characters or fewer.");